module.exports = __webpack_public_path__ + "static/media/ru.4ef29605.svg";